module.exports = __webpack_public_path__ + "img/a4.84c5b5e6.jpg";